import { db } from '../services/firebase';
import { doc, getDoc, setDoc, updateDoc } from 'firebase/firestore';

/**
 * Utilidad para asegurarse de que un usuario específico tenga permisos de administrador
 * Esto es útil para garantizar que las notificaciones funcionen correctamente
 */
export const ensureAdminPermissions = async (userId) => {
  if (!userId) {
    console.error('❌ No se proporcionó un ID de usuario válido');
    return false;
  }

  try {
    console.log(`🔍 Verificando permisos de administrador para el usuario: ${userId}`);
    
    // Verificar si el usuario existe
    const userRef = doc(db, 'users', userId);
    const userDoc = await getDoc(userRef);
    
    if (userDoc.exists()) {
      console.log('✅ Usuario encontrado en la base de datos');
      const userData = userDoc.data();
      
      // Verificar si ya tiene permisos de administrador
      if (userData.role === 'admin' && userData.isAdmin === true) {
        console.log('✅ El usuario ya tiene todos los permisos de administrador');
        return true;
      }
      
      // Actualizar permisos de administrador
      await updateDoc(userRef, {
        role: 'admin',
        isAdmin: true,
        permissions: {
          ...(userData.permissions || {}),
          admin: true
        },
        updatedAt: new Date()
      });
      
      console.log('✅ Permisos de administrador actualizados correctamente');
      return true;
    } else {
      console.warn('⚠️ El usuario no existe en la base de datos');
      
      // Crear un nuevo usuario con permisos de administrador
      await setDoc(userRef, {
        role: 'admin',
        isAdmin: true,
        permissions: {
          admin: true
        },
        email: `admin-${userId.substring(0, 6)}@paradise-landscaping.com`,
        displayName: 'System Administrator',
        createdAt: new Date(),
        updatedAt: new Date()
      });
      
      console.log('✅ Se creó un nuevo usuario con permisos de administrador');
      return true;
    }
  } catch (error) {
    console.error('❌ Error al configurar permisos de administrador:', error);
    return false;
  }
};

/**
 * Función para diagnosticar y corregir problemas con las notificaciones
 */
export const fixNotificationSystem = async (adminUserId) => {
  try {
    console.log('🔧 Iniciando diagnóstico del sistema de notificaciones...');
    
    // 1. Asegurar que el usuario tenga permisos de administrador
    const adminFixed = await ensureAdminPermissions(adminUserId);
    if (!adminFixed) {
      console.error('❌ No se pudieron configurar los permisos de administrador');
      return false;
    }
    
    console.log('✅ Sistema de notificaciones reparado correctamente');
    return true;
  } catch (error) {
    console.error('❌ Error al reparar el sistema de notificaciones:', error);
    return false;
  }
};

/**
 * Función para usar en la consola del navegador para reparar las notificaciones
 */
export const repairNotifications = async (userId) => {
  if (!userId) {
    console.error('❌ Debes proporcionar un ID de usuario válido');
    console.log('Ejemplo: repairNotifications("JlSANylhk7YUCSX5wj9sfuYRf6B3")');
    return false;
  }
  
  return await fixNotificationSystem(userId);
};

// Exportar la función para uso global
window.repairNotifications = repairNotifications;
